import { jwt } from "../jwt";
import { url } from "../url";
import { avcoreWorkerId } from "./avcore-worker-id.schema";

export const avcoreStreamApiCredentials = {
  type: "object",
  required: ["url", "worker", "token"],
  properties: {
    url: url,
    worker: avcoreWorkerId,
    token: jwt,
    origin: {
      type: "object",
      required: ["url", "worker"],
      properties: {
        url: url,
        worker: avcoreWorkerId
      },
      additionalProperties: false
    }
  },
  additionalProperties: false
};
